import { gpCommon } from '../app';
import { BrowserFeatureDetector } from '../../app-common/util/browser-feature-detector';
import { markdownDirective } from './markdown-directive';

gpCommon.directive('gpMarkdown', [() => markdownDirective()]);

gpCommon.directive('autofocus', ['$timeout', function ($timeout: ng.ITimeoutService) {
    return {
        link: function ($scope: ng.IScope, $element: ng.IAugmentedJQuery, attrs: ng.IAttributes) {
            $timeout(function () {
                focusInputField($element[0] as HTMLInputElement, attrs);
            }, 100);
        }
    };
}]);

// This is adapted from http://stackoverflow.com/questions/24243243/why-does-this-only-work-the-first-time-the-dialog-is-displayed/
gpCommon.directive('takeFocus', ['$timeout', function ($timeout: ng.ITimeoutService) {
    return {
        restrict: 'AC',
        link: ($scope: ng.IScope, $element: ng.IAugmentedJQuery, attrs: ng.IAttributes) => {
            $scope.$watch('opened', (newValue, oldVal, scope) => {
                $timeout(function () {
                    focusInputField($element[0] as HTMLInputElement, attrs);
                }, 100);
            });

            $scope.$on('gp-dialog-opened', (ev) => {
            })
        }
    };
}]);

gpCommon.directive('nofocus', [function () {
    return {
        link: ($scope: ng.IScope, $element: ng.IAugmentedJQuery, attrs: ng.IAttributes) => {

            $element.focus(e => {
                const elem = e.target as any;
                if (elem && elem.blur) {
                    elem.blur();
                }
            });
        }
    }
}]);

gpCommon.directive('nofocusMobile', [function () {
    return {
        link: ($scope: ng.IScope, $element: ng.IAugmentedJQuery, attrs: ng.IAttributes) => {
            $element.focus(e => {
                if (BrowserFeatureDetector.isSystemTablet()) {
                    const elem = e.target as any;
                    if (elem && elem.blur) {
                        elem.blur();
                    }
                }
            });
        }
    }
}]);

declare var htmx: any;

gpCommon.directive('htmxRouteProcess', ['$timeout', function ($timeout: ng.ITimeoutService) {
    return {
        restrict: 'A',
        link: function (scope, element) {
            $timeout(function () {
                if (typeof htmx !== 'undefined') {
                    htmx.process(element[0]);
                }
            }, 0);
        }
    };
}]);

// This is adapted from https://stackoverflow.com/questions/5272433/html5-form-required-attribute-set-custom-validation-message
gpCommon.directive('gpValidationText', [function () {
    return {
        restrict: 'A',
        link: ($scope: ng.IScope, $element: ng.IAugmentedJQuery, attrs: ng.IAttributes) => {

            let textToUse = attrs.gpValidationText;
            attrs.$observe<string>('gpValidationText', function (value) {
                textToUse = value;
            });

            let element = $element.get(0) as HTMLInputElement;
            element.addEventListener('invalid', () => element.setCustomValidity(textToUse));
            element.addEventListener('input', () => element.setCustomValidity(''));
        }
    };
}]);

function focusInputField(inputElement: HTMLInputElement, attrs: ng.IAttributes) {
    inputElement.focus();
    if (inputElement.select && attrs['autofocus'] !== 'noselect') {
        inputElement.select();
    } else {
        inputElement.setSelectionRange(0, 0);
    }
}
